/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';

function MedicoProtettoInfo({ mediciProtettoQuote, setShowGreeniaAI }) {
    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Medico Protetto</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Attività:
                                        </strong>
                                        {' '}
                                        {mediciProtettoQuote?.quotes?.activity?.name}
                                    </small>
                                </p>
                            </div>
                        </div>
                        <hr />
                        {mediciProtettoQuote?.quotes?.quotes?.map((quote, index) => (
                            <div className="row" key={index}>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Titolo:
                                            </strong>
                                            {' '}
                                            {quote?.name}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Prezzo:
                                            </strong>
                                            {' '}
                                            {quote?.price}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Massimale:
                                            </strong>
                                            {' '}
                                            {quote?.massimale}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <hr />
                                </div>
                            </div>
                        ))}

                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/rc-professionale-sanita/medico-protetto/${mediciProtettoQuote?.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MedicoProtettoInfo;
